const RFQConstants = {
  MainStatus: {
    PENDING: 1,
    ACCEPTED: 2,
    REJECTED: 3,
    EXPIRED: 4,
  },
  QuoteStatus: {
    QUOTE_SENT: 1,
    SHIPPER_ACCEPT: 2,
    TRANSPORTER_ACCEPT: 3,
    SHIPPER_REJECT: 4,
    TRANSPORTER_REJECT: 5,
    SHIPPER_SELECT: 6,
  },
  ApprovalStatus: {
    PENDING: 1,
    ACTIVE: 2,
    APPROVED: 3,
    REJECTED: 4,
  },
  ExpiryDuration: 2 * 60 * 60 * 1000,
  AcceptanceTime: 1 * 60 * 60 * 1000,
  NotificationType: {
    BID_EXPIRY: 'BID_EXPIRY',
    BID_SUBMISSION: 'BID_SUBMISSION',
  },
};

module.exports = { RFQConstants };
